import{jsxs as o,jsx as r}from"react/jsx-runtime";import{useState as e}from"react";import{styled as n}from"styled-components";import{useItemNames as t}from"../../../../domain/hooks/useItemName.mjs";import{titleName as a}from"../../../../domain/domain/UI/Title.name.mjs";const i=n.select`
  font:
    12px 'メイリオ',
    Meiryo,
    'ＭＳ Ｐゴシック',
    'MS PGothic',
    'ヒラギノ角ゴ Pro W3',
    'Hiragino Kaku Gothic Pro',
    Osaka,
    sans-serif;
  width: 200px;
  height: 20px;
  padding-right: 4px;
  padding-left: 4px;
  border: 1px solid #999999;
  border-radius: 8px;
  margin-top: 1px;
  background-color: #ffffff;
  color: #222222;
  outline: none;

  optgroup {
    color: #fff;
    background-color: #3a3a49;
    font-style: normal;
  }
  option {
    color: #222;
    background-color: #fff;
  }
`,l=n.button`
  background: url('images/home_16x16.png') no-repeat scroll left center transparent;
  border: none;
  min-width: 16px;
  min-height: 16px;
  margin-left: 3px;
`;function p(){const n=t(a),[p,c]=e("001");return o("span",{children:[o(i,{name:"login-state",id:"switch-login-state",value:p,onChange:o=>{c(o.currentTarget.value)},children:[r("optgroup",{label:n("switchCompany"),children:r("option",{value:"001",children:"株式会社プロシップ"})}),r("optgroup",{label:n("groupManagement"),children:r("option",{value:"000",children:"システムの管理"})})]}),r(l,{name:"switch-default",className:"switch-default"})]})}export{p as CompanySwitch};
